module.exports = __webpack_public_path__ + "static/media/twitter-icon.7e390d8a.svg";